import {Component, OnInit, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from 'ng2-validation';
import {Router, ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {EmissionService} from 'services/emission.service';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {Constants} from 'config/constants';
import {SpinnerService} from 'services/spinner.service';

@Component({
    selector: 'tpc-site-add',
    templateUrl: './site-add.component.html',
    styleUrls: ['./site-add.component.css']
})
export class SiteAddComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private zip;
    private countryid;
    private subregion;
    private isFormSubmited = false;
    private defaultAmountValue = 0;
    private defaultUnitsValue = 'gallons';
    private defaulteleUnitsValue = 'kWh';
    private defaultnatUnitsValue = 'ccf';
    private defaultproUnitsValue = 'gal';
    private defaultIntervalValue = 'month';

    public homeForm: FormGroup;
    public unitsList = [
        {key: 'gallons', value: 'Gallons'}
    ];
    public intervalsList = [
        {key: 'month', value: 'per Month'},
        {key: 'year', value: 'per Year'}
    ];

    constructor(private emissionService: EmissionService,
                private footerService: FooterNavbarService,
                private activatedRoute: ActivatedRoute,
                private router: Router,
                private fb: FormBuilder,
                private spinner: SpinnerService) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmited = true;
            if (this.homeForm.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
        this.zip = this.activatedRoute.queryParams['_value']['zip'];
        this.countryid = this.activatedRoute.queryParams['_value']['countryid'];
        this.subregion = this.activatedRoute.queryParams['_value']['subregion'];

        if (!this.zip) {
            this.router.navigate(['/']);
        }
    }

    private createForm() {
        this.homeForm = this.fb.group({
            electricityAmount: [this.defaultAmountValue, this.getNumbersValidatorsArray()],
            naturalGasAmount: [this.defaultAmountValue, this.getNumbersValidatorsArray()],
            heatingOilAmount: [this.defaultAmountValue, this.getNumbersValidatorsArray()],
            propaneAmount: [this.defaultAmountValue, this.getNumbersValidatorsArray()],
            gasolineAmount: [this.defaultAmountValue, this.getNumbersValidatorsArray()],
            dieselAmount: [this.defaultAmountValue, this.getNumbersValidatorsArray()],

            electricityUnit: [this.defaulteleUnitsValue, [Validators.required]],
            naturalGasUnit: [this.defaultnatUnitsValue, [Validators.required]],
            heatingOilUnit: [this.defaultUnitsValue, [Validators.required]],
            propaneUnit: [this.defaultproUnitsValue, [Validators.required]],
            gasolineUnit: [this.defaultUnitsValue, [Validators.required]],
            dieselUnit: [this.defaultUnitsValue, [Validators.required]],

            electricityInterval: [this.defaultIntervalValue, [Validators.required]],
            naturalGasInterval: [this.defaultIntervalValue, [Validators.required]],
            heatingOilInterval: [this.defaultIntervalValue, [Validators.required]],
            propaneInterval: [this.defaultIntervalValue, [Validators.required]],
            gasolineInterval: [this.defaultIntervalValue, [Validators.required]],
            dieselInterval: [this.defaultIntervalValue, [Validators.required]],
        });
    }

    private next() {
        let calculatorName = Constants.calculators.business;
        let categoryName = 'site';
        let subRegion = (this.subregion = 'na'? 'N/A': this.subregion);
        let params = {
            ZIP: this.zip,
            SubRegion: subRegion,
            CountryID: this.countryid,
            energies: this.getEnergiesParamsArray(),
        };

        if (this.dataIsNotEmpty()) {
            this.spinner.show();
            this.emissionService.getEmissionValue(params, calculatorName, categoryName).subscribe(
                response => {
                    let input = response.body[0].input[0];
                    this.emissionService.setEmission({
                        category: Constants.categories.business.site,
                        emission: {
                            emission: input.emmission,
                            emissionTrees: input.emissionTrees,
                            DollarAmt: input.DollarAmt,
                            DollarAmtMonthly: input.DollarAmtMonthly
                        }
                    });


                    this.footerService.skip();
                    this.spinner.hide();
                }
            );
        } else {
            this.emissionService.setEmission({
                category: Constants.categories.business.site,
                emission: {
                    emission: 0,
                    emissionTrees: 0,
                    DollarAmt: 0,
                    DollarAmtMonthly: 0
                }
            });

            this.footerService.skip();
        }
    }

    private getEnergiesParamsArray() {
        return ['electricity', 'naturalGas', 'heatingOil', 'propane', 'gasoline', 'diesel'].map((name) => {
            return {
                name: name,
                amount: this.getFV(name + 'Amount'),
                unit: this.getFV(name + 'Unit'),
                multipier: this.getFV(name + 'Interval') === this.defaultIntervalValue ? 12 : 1
            };
        });
    }

    private dataIsNotEmpty() {
        return !!+this.getFV('electricityAmount') ||
            !!+this.getFV('naturalGasAmount') ||
            !!+this.getFV('heatingOilAmount') ||
            !!+this.getFV('propaneAmount') ||
            !!+this.getFV('gasolineAmount') ||
            !!+this.getFV('dieselAmount');
    }

    private getNumbersValidatorsArray() {
        return [CustomValidators.min(0), CustomValidators.digits];
    }

    checkError(param) {
        return this.homeForm.get(param).status === 'INVALID' && (this.isFormSubmited || this.homeForm.get(param).touched);
    }

    getFV(param) {
        return this.homeForm.get(param).value;
    }

    ngOnDestroy() {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/business-calculator/site/site-add/site-add.component.ts